import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    de: {
      menu: 'Menü',
      sprecher: 'Sprecher',
      front_headline: 'Wähle das passende Format für dein Produkt.',
      direkt_zu: 'Direkt zu:',
      playshowreel: 'Showreel abspielen',
      stopshowreel: 'Showreel schließen',
      startfilm: 'Film starten',
      showmore: 'Mehr ansehen',
      details: 'Details',
      playvideo: 'Video abspielen',
      zur: 'Zur Sprecher-',
      uebersicht: 'übersicht',
      referenzen: 'Referenzen',
      reftext: 'Eine Auswahl an Firmen, mit denen wir zusammengearbeitet haben.',
      kontakt: 'Kontakt',
      kontaktbtn : 'Kontakt aufnehmen',
      next: 'Nächstes Projekt',
      prev: 'Vorheriges Projekt',
      placeholder_1: 'Dieses Video wird über vimeo bereitgestellt. Um das Video zu sehen, müssen Sie in den ',
      dse_link: 'Datenschutz-Einstellungen',
      placeholder_2: ' die Media-Cookies akzeptieren.',
      your_project: 'Ihr Projekt',
      kunde_hero_1: 'hier haben wir die passenden Formate',
      kunde_hero_2: 'für Ihr Projekt zusammengestellt. Film ab!',
      imagefilme: 'Imagefilme',
      produktvideos: 'Produktvideos',
      werbespots: 'Werbespots',
      aerials: 'Luftaufnahmen',
      erklaervideos: 'Erklärvideos',
      produktfotos: 'Produktfotos',
      prices: 'Kostenaufstellung',
    },
    en: {
      menu: 'Menu',
      sprecher: 'Speakers',
      front_headline: 'Choose the right format for your product.',
      direkt_zu: 'Directly to:',
      playshowreel: 'Play showreel',
      stopshowreel: 'Stop showreel',
      startfilm: 'start film',
      showmore: 'See more',
      details: 'details',
      playvideo: 'Play video',
      zur: 'To the',
      uebersicht: 'speakers',
      referenzen: 'references',
      reftext: 'A small collection of companies, whom we have worked with.',
      kontakt: 'Contact',
      kontaktbtn : 'Get in contact',
      next: 'next project',
      prev: 'previous project',
      placeholder_1: 'This video is hosted on vimeo. To see the video, go to the ',
      dse_link: 'Privacy settings',
      placeholder_2: ' and accept the media-cookies.',
      your_project: 'Your project',
      kunde_hero_1: 'here we put together matching examples',
      kunde_hero_2: 'for your project.',
      imagefilme: 'image films',
      produktvideos: 'product videos',
      werbespots: 'commercials',
      aerials: 'aerials',
      erklaervideos: 'explanation videos',
      produktfotos: 'product fotos',
      prices: 'Statement of costs',
    }
  }
});
